import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

export const Id = pipe(
	string,
	parse((s) => (s.startsWith(`usage:`) ? success(s) : failure(s, 'Invalid wholehouse usage id')))
);
